import React from 'react';
import ReactDOM from 'react-dom';
import {getWsProgressColor,getPaceText,getPriorityText,getHealthText,WbUniqueIdMixin,WbMarkdownHtml} from '../../utils/common';
import ImgIconComp from './../imgcomp';
import CustomeAttrDisplay from './../customeAttrDisplay';
import {HEALTH_GOOD, HEALTH_OK, HEALTH_RISK,
    PACE_FAST, PACE_SLOW, PACE_STEADY,
    PORIORITY_P4, PORIORITY_P1, PORIORITY_P2, PORIORITY_P3, PORIORITY_P5
} from '../../resources/component';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
class ViewWsPopupComp extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            chartTasks: this.props.chartTasks||{},
            item : this.props.item,
            chageTeamLeadPopup : false,
            healthPopup: false,
            pacePopup: false,
            priorityPopup: false,
            startDatePopup: false,
            endDatePopup: false,
            ckeditor:false,
            wsNameClick: false,
            changeLeadName:{},
            actionDone: false,
            paceText: '',
            pace:this.props.item.pace,
            health : this.props.item.health,
            priority :this.props.item.priority,
            target_date : this.props.item.target_date,
            start_date  : this.props.item.start_date,
            leadName : this.props.item.owner_firstname + " " + this.props.item.owner_lastname,
            leadImagePath : this.props.item.owner_picture,
            owner : this.props.item.owner,
            goal : this.props.item.goal,
            name_truncate : this.props.item.wsName,
            wsName : this.props.item.name,

            healthName: '',
            healthImage: '',
            priorityText: '',
            displayText : {display: 'block'},
            displayTextEdit : {display: 'none'},
            canEditAttribute : false,
            canView: false,
            firstName : this.props.item.owner_firstname,
            lastName : this.props.item.owner_lastname,
            selTab : 'descTab',
            customAttribute: []
        };
        this.initCalnder = this.initCalnder.bind(this);
        this.selectHealt = this.selectHealt.bind(this);
        this.selectPriority = this.selectPriority.bind(this);
        this.selectPace = this.selectPace.bind(this);
        this.selectDueDate = this.selectDueDate.bind(this);
        this.selectStartDate = this.selectStartDate.bind(this);
        this.selectLead = this.selectLead.bind(this);
        this.closeWsPopup = this.closeWsPopup.bind(this);
        this.teamLeadPopupClick = this.teamLeadPopupClick.bind(this);
        this.healthPopupClick = this.healthPopupClick.bind(this);
        this.pacePopupClick = this.pacePopupClick.bind(this);
        this.priorityPopupClick = this.priorityPopupClick.bind(this);
        this.updateGoal = this.updateGoal.bind(this);
        this.clickStartDate = this.clickStartDate.bind(this);
        this.clickEndDate = this.clickEndDate.bind(this);
        this.cKeditorLoad = this.cKeditorLoad.bind(this);
        this.selectWsName = this.selectWsName.bind(this);
        this.wsNameEditing = this.wsNameEditing.bind(this);
        this.handlePopupClick = this.handlePopupClick.bind(this);
        this.submitWsProps = this.submitWsProps.bind(this);
        this.cancelWsProps = this.cancelWsProps.bind(this);
        this.onWsNameChange = this.onWsNameChange.bind(this);
        this.remainingDays = this.remainingDays.bind(this);
        this.syncNowFunction = this.syncNowFunction.bind(this);
        this.deleteWs = this.deleteWs.bind(this);
        this.updateCustomAttribute = this.updateCustomAttribute.bind(this);
        this.selTab = this.selTab.bind(this);
        this.setDateFieldValue = this.setDateFieldValue.bind(this);
    }

    componentDidMount() {
        showLoaderWidget($("#content"));
        var _this = this;
        let healthName = getHealthText(_this.props.item.health);
        let priorityText = getPriorityText(_this.props.item.priority);
        let paceText = getPaceText(_this.props.item.pace);
        this.setState({
            healthName:healthName.healthName,
            healthImage:healthName.healthImage,
            priorityText:priorityText,
            paceText:paceText
        })
        $.ajax({
            url: wbConfig.baseUrl + '/board/wsEditPermition?id=' + this.state.item.id,
            type: 'get',
        })
        .done(function(response){
            _this.setState({
                  canEditAttribute: response.canEdit,
                  customAttribute: response.customAttribute,
                  canView: response.canView
            }, function(){
                _this.initCalnder($('#wsTeamStartDate'), 'start_date');
                _this.initCalnder($('#wsTeamEndDate'), 'target_date');
                if(response.canEdit && !_this.state.ckeditor){
                    console.log("clicked")
                    _this.cKeditorLoad();
                }
            });
        })
        window.addEventListener("click", this.handlePopupClick, true);

        /*for change team lead info*/
        var urlappent = "&canAddNonMember=false&canAddNonMemberDefaultTeam=false&showNonMemberAdd=false&self=false&showOrgUsers=false";
        var JsonResponse = "&returnJson=true"
        if(typeof wbConfig.baseUrl !== 'undefined'){
            showLoaderWidget($("#content"));
            $.ajax({
                url: wbConfig.baseUrl + '/activity/ViewAssigniList?board=' + this.state.item.id + urlappent + JsonResponse,
                type: 'get',
            })
            .fail(function(response){
                _this.setState({
                      changeLeadName: response.data,
                });
                removeLoaderWidget();
            })
        }
        removeLoaderWidget();
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.handlePopupClick, true);
    }

    initCalnder(id, dateField){
        let _this = this;
        let datePickerOptions = {
                showAnim: 'slide',
                dateFormat: 'mm/dd/yy',
                onSelect: function(date){
                    if(dateField == 'start_date'){
                        $("#wsTeamEndDate").datepicker( 'option', 'minDate', date );
                        _this.selectStartDate(date);
                    }
                    else if(dateField == 'target_date'){
                         $("#wsTeamStartDate").datepicker( 'option', 'maxDate', date );
                         _this.selectDueDate(date);
                    }
                },
                onChangeMonthYear: function(year, month, inst){
                var buttonPane = $( inst.input ).datepicker( "widget" );
                $(buttonPane).find("button.newStyleForDatePicker").remove();
                setTimeout(function() {
                    var btn = $('<button class=" clearstyles newStyleForDatePicker" type="button">Clear</button>');
                        btn
                        .off("click")
                        .on("click", function () {
                        $.datepicker._clearDate( inst.input );
                    });
                    if($('.wbmodal-datepicker .newStyleForDatePicker').length == 0){
                        btn.appendTo( buttonPane );
                    }
                }, 1 );
            },
            beforeShow: function(input){
                $("#ui-datepicker-div").addClass("dataTimePicker wbmodal-datepicker");
                setTimeout(function() {
                    var buttonPane = $( input ).datepicker( "widget" );
                    var btn = $('<button class=" clearstyles newStyleForDatePicker" type="button" >Clear</button>');
                    btn
                        .off("click")
                        .on("click", function () {
                        $.datepicker._clearDate( input );
                    });
                    if($('.wbmodal-datepicker .newStyleForDatePicker').length == 0){
                        btn.appendTo( buttonPane );
                    }
                }, 1 );
            }
        };
        var minDate = "";
        if(dateField == 'start_date' && this.state.target_date){
            var d = new Date();
            var date = new Date(this.state.target_date*1000 + d.getTimezoneOffset() * 60000)
            minDate = ((date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear());
            datePickerOptions.maxDate = minDate;
        }
        var maxDate ="";
        if(dateField == 'target_date' && this.state.start_date){
            var d = new Date();
            var date = new Date(this.state.start_date*1000 + d.getTimezoneOffset() * 60000)
            maxDate = ((date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear());
            datePickerOptions.minDate = maxDate;
        }

        if(this.state.canEditAttribute){
            $(id).datepicker(datePickerOptions);
        }
    }

    selectHealt(healthName,healthImage,health){
        this.setState({
            healthName: healthName,
            healthImage: healthImage,
            health : health,
            actionDone : true,
            healthPopup:false,
        });
    }

    selectPriority(proText,proValue){
        this.setState({
            priorityText: proText,
            priority :proValue,
            actionDone : true,
            priorityPopup: false,
        });
    }

    selectPace(paceText,paceVal){
        let _this = this;
        _this.setState({
            paceText :paceText,
            pace : paceVal,
            actionDone : true,
            pacePopup: false,
        });
    }

    selectDueDate(date){
        let date_;
        var s=date.split("/");
        if(s.length>1){
           date_ =  new Date(s[2], s[0]-1, s[1]).getTime() / 1000
        }
        this.setState({
            target_date : date_,
            actionDone : true,
        });
    }

    selectStartDate(date){
        let date_;
        var s=date.split("/");
        if(s.length>1){
           date_ =  new Date(s[2], s[0]-1, s[1]).getTime() / 1000
        }
        this.setState({
            start_date  : date_,
            actionDone : true,
        });
    }

    selectLead(name,lastName,pic,leadId){
        this.setState({
            leadName : name+lastName,
            lastName:lastName,
            firstName:name,
            leadImagePath : pic,
            owner : leadId,
            actionDone : true,
            chageTeamLeadPopup : false,
        });
    }

    closeWsPopup(){
        if (typeof this.props.onClose === 'function') {
            this.props.onClose();
        }
        else {
            this.mountId = document.getElementById('wsEditPopup');
            if(this.mountId){
                ReactDOM.unmountComponentAtNode(this.mountId);
            }
            $('#wsEditPopup').dialog('close');
        }
    }

    teamLeadPopupClick(){
        let _this = this;
        setTimeout(() => _this.setState({
                            chageTeamLeadPopup: true,
                        }), 10);
    }

    healthPopupClick(){
        let _this = this;
        setTimeout(() => _this.setState({
                            healthPopup: true,
                        }), 10);
    }

    pacePopupClick(){
        let _this = this;
        setTimeout(() => _this.setState({
                            pacePopup: true,
                        }), 10);
    }

    priorityPopupClick(){
        let _this = this;
        setTimeout(() => _this.setState({
                            priorityPopup: true,
                        }), 10);
    }

    updateGoal(content){
        this.setState({
            goal : content,
            actionDone : true,
        });
    }

    clickStartDate(canEdit){
        if(canEdit){
            $('#wsTeamStartDate').datepicker("show");
        }
    }

    clickEndDate(canEdit){
        if(canEdit){
            $('#wsTeamEndDate').datepicker("show");
        }
    }

    setDateFieldValue(date){
        const timezone = this.props.item?.owner_timezone ?? 'UTC';
        return date ? moment.tz(date * 1000, timezone).format("MMM DD, yy") : "M D, Y";
    }

    cKeditorLoad(){
        var _this = this;
        console.log('before cKeditorLoad');
        console.log('before cKeditorLoad');
        if( true && !this.state.ckeditor && this.state.canEditAttribute){
            console.log('after cKeditorLoad');
            $('.pencilImg').hide();
            this.setState({
                ckeditor:true,
            });
            var eleIdB = 'editDisc';
            CKEDITOR.disableAutoInline = true;
            CKEDITOR.timestamp = css_js_version_control;
            var wsGoalEditorV = CKEDITOR.replace(eleIdB, {
                extraAllowedContent: 'a(documentation);abbr[title];code',
                startupFocus: true,
                // removePlugins: 'magicline,liststyle,tabletools,scayt,contextmenu,elementspath,forms',
                extraPlugins: 'chkstrike,confighelper,linkclickable,autogrow,pasteFromGoogleDoc',
                // uploadUrl: '/uploader/upload.php',
                autoGrow_onStartup: false,
                resize_enabled : false,
                height :  '120px',
                autoGrow_maxHeight : 100,
                autoGrow_bottomSpace: 0,
                line_height : '8px',
                sharedSpaces: {
                    top: 'top2'
                },
                fillEmptyBlocks: false,
                shiftEnterMode : CKEDITOR.ENTER_BR,
                enterMode : CKEDITOR.ENTER_BR,
                allowedContent : true,
                entities: false,
                basicEntities: false,
            });
            wsGoalEditorV.on('instanceReady', function(ev) {
                ev.editor.focus();
                var s = ev.editor.getSelection(); // getting selection
                var selected_ranges = s.getRanges(); // getting ranges
                var node = selected_ranges[0].startContainer; // selecting the starting node
                var parents = node.getParents(true);
                if (parents && parents.length > 2) {
                    node = parents[parents.length - 3].getFirst();
                }
                while (true) {
                    var x = node.getNext();
                    if (x == null) {
                        break;
                    }
                    node = x;
                }
                s.selectElement(node);
                selected_ranges = s.getRanges();
                selected_ranges[0].collapse(false);  //  false collapses the range to the end of the selected node, true before the node.
                s.selectRanges(selected_ranges);  // putting the current selection there
            });
            wsGoalEditorV.on('change', function () {
                var content = wsGoalEditorV.getData();
                _this.updateGoal(content);
            });


        }
    }

    selectWsName(){
        var displayEdit;
        var display;
        var isEditable = $('#edtWsName').attr("data-status");
        if(isEditable == 'false'){
              $('#edtWsName').show();
              $('#edtWsNameText').hide();
            return;
        }else{
            var displayEdit = {display:"block"};
            var display  = {display:"none"};
            $('#edtWsName').hide();
            $('#edtWsNameText').show();
        }
        let _this = this;
        setTimeout(() => _this.setState({
                            actionDone : true,
                            wsNameClick: true,
                            displayTextEdit :displayEdit,
                        }), 10);
    }

    wsNameEditing(e){
        if (e.keyCode === 13) {
          document.execCommand('insertHTML', false, '<br><br>');
          document.execCommand('insertHTML', false, '<div></div>');
          return false;
        }
    }

    handlePopupClick(e) {
        if (!$('.wsEditProps').is(e.target) // if the target of the click isn't the container...
            && $('.wsEditProps').has(e.target).length === 0) {
            $('.pencilImg').show();
            var name = $('#edtWsName').html();
            if(name){
                name = name.replace("<div>","");
                name = name.replace("</div>","");
                name = name.replace("<br>","");
                if(name.length != 0){
                    this.setState({
                        wsNameClick : false,
                    });
                }
            }
            this.setState({
                chageTeamLeadPopup: false,
                healthPopup : false,
                priorityPopup :false ,
                pacePopup : false,
                //ckeditor : false,

            });
        }

        if(this.state.canEditAttribute){
            if ($('#edtWsNameText').is(e.target) // if the target of the click isn't the container...
                && $('#edtWsNameText').has(e.target).length === 0) {
                this.setState({
                    displayTextEdit : {display: 'block'},
                     wsNameClick: true,
                });
            }else{
                let wsName = $('#edtWsNameText').val();
                if(wsName){
                    this.setState({
                       displayTextEdit : {display: 'none'},
                    });
                    $('#edtWsName').show();
                }else{
                    this.setState({
                        wsNameClick:true,
                    })
                }
            }
        }
    }

    /* Trigger when save click*/
    submitWsProps(e){
        if(this.state.actionDone == false){
            this.closeWsPopup();
            return false; //if noting is chaged no need to save
        }
        if (CKEDITOR.instances.editDisc){
            CKEDITOR.instances.editDisc.destroy();
            this.setState({
                ckeditor:false
            })
            $('.pencilImg').show();
        }
       let _this = this;
       var id            =  _this.props.item.id;
       var name          =  $('#edtWsName').html();
       var start_date    =  $('#wsTeamStartDate').val();
       var target_date   =  $('#wsTeamEndDate').val();
       var leadName      =  _this.state.leadName;
       var leadImagePath =  _this.state.leadImagePath;
       var owner         =  _this.state.owner;
       var paceText      =  _this.state.paceText;
       var pace          =  _this.state.pace;
       var healthName    =  _this.state.healthName;
       var healthImage   =  _this.state.healthImage;
       var health        =  _this.state.health;
       var color         =   getWsProgressColor(_this.state.health);
       var priority      =  this.state.priority;
       var goal          =  this.state.goal;
       var name_truncate =  "";
       let lastName      =  _this.state.lastName;
       let firstName     =  _this.state.firstName;
       name = name.replace("<div>","");
       name = name.replace("</div>","");
       var edtWsNameText =  $('#edtWsNameText').val();
       if(name == '<br>'|| name.length == 0 || edtWsNameText.length == 0){
            $('#edtWsName').trigger('focus');
            return false;
       }
       if(name.length >= 23){
            name_truncate = name.substr(0, 23) + "...";
       }else{
           name_truncate = name;
       }
       name = name.replace(/&amp;/g, '&');
       name = name.replace(/&nbsp;/g, ' ');
       if (start_date) {
        start_date = moment(moment(start_date).format('MM/DD/YYYY')).format('X');
       }
       else {
            start_date = '';
       }
       if (target_date) {
            target_date = moment(moment(target_date).format('MM/DD/YYYY')).format('X');
        }
        else {
            target_date = '';
        }

       /* save updated values in DB */
        showLoaderWidget($("#content"));
         var customAttribute          = this.state.customAttribute;
        let customAttributeModified = [];
        if(customAttribute.length) {
             customAttribute.map(item => {
                item.attributes.map(filed => {
                    var selectItems = {
                        'id': filed.id,
                        'value': filed.ca_value
                    }
                    customAttributeModified.push(selectItems)
                });
            });
        }
        let team_id = $('.editHead').attr('id');
        var param = {id: id, name: name,owner:owner,start_date:start_date,target_date:target_date,health:health,priority:priority,pace:pace,goal:goal,team_id:team_id,customAttribute:customAttributeModified};
        let paramObj = {id: id, name: name,owner:owner,user_id:owner,owner_firstname:firstName,owner_lastname:lastName,owner_picture:leadImagePath,start_date:start_date,target_date:target_date,health:health,priority:priority,pace:pace,goal:goal,team_id:team_id};
        $.post(wbConfig.baseUrl + '/activity/updateAllWsAttribute',param, function (data, status) {
             if(data.error){
                _this.closeWsPopup();
                removeLoaderWidget();
                return false;
             }
            _this.setState({
                actionDone : false,
            });
            /*update redux comp */
            _this.props.actions.BoardWsDataUpate(paramObj);

            var block = $('.block-1-head').height();
            $('.gantt-chart-wrapper #gantt').height(block);
            $('.date-title-header').attr("height",21);
            removeLoaderWidget();
            _this.closeWsPopup();
            var wsLiObj = $('.workstreamLeftCol .uiMenu li.workstreamRender#workstream_' + id);
            var wsName = name;
            var wsNameModified = wsName;
            if($(wsLiObj).hasClass('retiredStreamsWs')){
                wsNameModified = wsNameModified + ': ' + $(wsLiObj).attr('data-tname');
            }
            wsNameModified = wsNameModified.replace(/&amp;/g, '&');
            wsNameModified = wsNameModified.replace(/&nbsp;/g, ' ');
            if ($(wsLiObj).find('img').length){
                $(wsLiObj).html('<img width="10px" height="8px" src="' + wbConfig.baseUrl + '/images/icons/widget/total_done.png"> ' + wsNameModified).attr("title", wsNameModified);
            }
            else{
                $(wsLiObj).text(wsNameModified).attr("title", wsNameModified);
            }
            if(typeof _this.props.saveCallback === 'function'){
                _this.props.saveCallback(id);
            }
        });

    }

    /* trigger when close buttoin click */
    cancelWsProps(){
        this.closeWsPopup();
    }

    onWsNameChange(e){
        let wsName = $('#edtWsNameText').val();
        if(wsName.length > 128){
            e.preventDefault();
        }

        if(wsName){
            wsName = wsName.replace(/&amp;/g, '&');
            wsName = wsName.replace(/&nbsp;/g, ' ');
            this.setState({
                wsName : wsName,
            });
        }
    }

    remainingDays(startDate,endData){
        if((!startDate) ||  (!endData)){
            return ;
        }else{
            let today = moment();
            let start = moment.unix(startDate);
            let end =  moment.unix(endData);
            let tot_days =  (end.diff(start, 'days'))%7;
            let tot_weeks =  end.diff(start, 'weeks');
            let rem_days = end.diff(today, 'days')+1;
            let rem_weeks = parseInt(rem_days/7);
            rem_weeks = (rem_weeks < 0) ? 0 : rem_weeks;
            tot_weeks = (tot_weeks < 0) ? 0 : tot_weeks;
            let return_ =   rem_weeks +" of " + tot_weeks+((tot_days!=0) ? "."+tot_days :" " )+" Weeks Remaining";
            return  return_;
        }
    }

    syncNowFunction(){
        let items = this.state.items;
        let ws_id = this.state.item.id;
        if (ws_id == '' || typeof (ws_id) === undefined) {
        return false;
        }
        wsImportSyncData(ws_id);
    }

    deleteWs(id){

    }

    updateCustomAttribute(customAttribute) {
        this.setState({
            customAttribute:customAttribute,
            actionDone : true,
        })
    }

    selTab(tab){
        if(tab == 'descTab'){
            $('#cke_editDisc').show();
        }else{
            $('#cke_editDisc').hide();
        }
        this.setState({
            selTab:tab,
        })
    }

    render(){
        const { t } = this.props;
        let items = this.state.item;
        let canEditAttribute = this.state.canEditAttribute;
        let canView = this.state.canView;
        var left = {
            float: (canEditAttribute && !this.state.ckeditor) ? 'left' : ''
        };
        let cursor = canEditAttribute ? "clickable" : "nonClickable";
        var EdtWsName = (this.state.wsNameClick && canEditAttribute) ? "EdtWsName wsNameSelect" : "EdtWsName";
        let teamNames = this.state.changeLeadName;
        let paceText = this.state.paceText;
        let pace = this.state.pace;
        let healthName = this.state.healthName;
        let healthImage = "/images/icons/"+this.state.healthImage;
        let health = this.state.health;
        let priorityText = this.state.priorityText;
        let priority = this.state.priority;
        let target_date = this.state.target_date;
        let start_date = this.state.start_date;
        let leadName = this.state.leadName;
        let leadImagePath = this.state.leadImagePath;
        let owner = this.state.owner;
        let goal = this.state.goal;
        let wsName = this.state.wsName;
        let displayText = this.state.displayText;
        let displayTextEdit = this.state.displayTextEdit;
        let team_id = this.state.item.team_id;
        let ws_id = this.state.item.id;
        let is_extern = this.state.item.is_extern
        let externalAppName = (this.state.item.externalAppName) ? this.state.item.externalAppName : '';
        let extAppLinkName = (this.state.item.extAppLinkName) ? this.state.item.extAppLinkName : '';
        let extAppLable = (externalAppName != '' )? externalAppName+" Import: "+extAppLinkName:"";
        let showSync = (is_extern == true && canEditAttribute == true)? true : false;
        let boxtextWidth = (showSync == true)? '66%' : '93%' ;
        $('.deleteWsPage').attr("has_action","true");
        var wsUrl =  wbConfig.baseUrl + '/activity/workstreams?id=' + ws_id;
        let selTab = this.state.selTab;
        let customAttribute = this.state.customAttribute;
        return (
            <div className="wsEditWrapper">
                <form id="wsPrpsEdit">
                    <div className="editHead"  id={team_id}>
                        <div className="boxs headTextLine boxtextWidth" style={{width:boxtextWidth}}>
                            <div className="aiEditPageTitleCellddd" >
                                <div className="open_ws">
                                { (canEditAttribute || canView) && <a href={wsUrl} target="_blank"><ImgIconComp id="open_ws" /></a> }
                                </div>
                                <div id="edtWsName" data-status={canEditAttribute} className="EdtWsName displayInline" onClick={this.selectWsName} >{wsName}</div>
                                {canEditAttribute &&
                                    <textarea  maxLength="128" id="edtWsNameText"
                                        style={displayTextEdit} className={EdtWsName}
                                        name="goal" tabIndex="1"
                                        onChange={this.onWsNameChange} defaultValue={wsName} />
                                }

                            </div>
                            {
                                !is_extern &&
                                <div className="remaining">{this.remainingDays(start_date,target_date)}</div>
                            }
                            {
                                is_extern &&
                                <div className="extAppName truncateText">{extAppLable}</div>
                            }
                        </div>
                        {
                            showSync &&
                            <div className="syncNow displayInline" onClick={this.syncNowFunction}>
                                <div className="syncImage"><img style={{padding:"0px 5px"}} src={wbConfig.baseUrl+"/images/icons/sync_ws_blue.png"}/></div>
                                <div className="syncNowLable">{t("Synch Now")}</div>
                            </div>
                        }
                        {
                            showSync &&
                            <div className="deleteWsPage"    id={ws_id}  wsid={ws_id} onClick={(e)=> this.deleteWs(ws_id)}>{t("Delete Ws")}</div>
                        }
                        <div className={"closeWsPopup right clickable displayInline"} onClick={this.closeWsPopup}>
                            <ImgIconComp id="close" />
                        </div>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div className="wsEdtProps">
                        <div className="wsEdtPropsWrpper">
                            <div className="wsEditLaedDetails">
                                <div onClick={this.teamLeadPopupClick} className="teamNameDivWrapper">
                                    <div className="">
                                        <div className="wsEditHeadText leadLable">{t("LEAD")}</div>
                                        <div>
                                            <div className="wsEditImageWrapper" id="teamOwner" data-url={owner}>
                                                <img className="wsEditLaedImage fitProfileImage" src={leadImagePath} border="0" width="40" height="40" />
                                            </div>
                                            <div className={"wsEditLeadName wsEditLables "+cursor}>{leadName}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="showTeamLeadPopup" className="wsEditProps showTeamLeadPopup">
                                {canEditAttribute && this.state.chageTeamLeadPopup &&  <ChageTeamLead  selectLead={this.selectLead} item={items.id} leadList={teamNames} t={t}/>}
                            </div>
                            <div className="wsEditCalndDetails">
                                <div className="wsEditStartDateWrapper">
                                    <div className="wsEditHeadText">{t("START DATE")}</div>
                                    <div className="" id="wsEditStartDate">
                                        <input  type="text" className={"wsEditStartDate discEdit "+cursor} name="start_date" id="wsTeamStartDate" value={this.setDateFieldValue(start_date)}/>
                                    </div>
                                    <div className={"wsEditStartImg "+cursor} onClick={(e)=>this.clickStartDate(canEditAttribute)}><img  src={wbConfig.imageCdnUrl+"/images/icons/edit_images/due_grey.png"}/></div>
                                </div>
                                <div className="wsEditEndDateWrapper">
                                    <div className="wsEditHeadText">{t("END DATE")}</div>
                                    <div className="">
                                        <input type="text" className={"wsEditEndDate discEdit "+cursor} name="end_date" id="wsTeamEndDate" value={this.setDateFieldValue(target_date)}/>
                                    </div>
                                    <div className={"wsEditEndImg "+cursor} onClick={(e)=>this.clickEndDate(canEditAttribute)} > <img  src={wbConfig.imageCdnUrl+"/images/icons/edit_images/due_grey.png"}/></div>
                                </div>
                            </div>
                            <div className="wsEditPropsDetails">
                                <div className="wsEditHealth">
                                    <div className="wsEditHeadText">{t("HEALTH")}</div>
                                    <div onClick={this.healthPopupClick}>
                                        <div className={"wsEditLables wsEditHealthText "+cursor} id="wsEditHealthText" data-url={health} onClick={this.healthPopupClick} >
                                            {healthName}
                                        </div>
                                        <div className="wsEditHealthImg">
                                            <img  src={wbConfig.imageCdnUrl+healthImage} border="0" width="10" height="10" />
                                        </div>
                                        <div className="clear"></div>
                                    </div>
                                        <div id="showHealth" className="wsEditProps">
                                                {canEditAttribute && this.state.healthPopup &&  <ChangeHealth  selectHealt={this.selectHealt} t={t}/>}
                                        </div>
                                </div>
                                <div className="wsEditPriority">
                                    <div className="wsEditHeadText">{t("PRIORITY")}</div>
                                    <div className={"wsEditLables wsEditPriorityText "+cursor} id="wsEditPriority" data-url={priority} onClick={this.priorityPopupClick}>{priorityText} </div>
                                        <div id="showPriority" className="wsEditProps">
                                                {canEditAttribute && this.state.priorityPopup &&  <ChangePriority selectPriority={this.selectPriority} t={t}/>}
                                        </div>
                                </div>
                                <div className="wsEditPeace">
                                    <div className="wsEditHeadText">{t("PACE")}</div>
                                    <div className={"wsEditLables wsEditPeaceText "+cursor} id="wsEditPeaceText" data-url={pace} onClick={this.pacePopupClick}>{paceText}</div>
                                        <div id="showPacePopup" className="wsEditProps">
                                                {canEditAttribute && this.state.pacePopup &&  <ChangePace selectPace={this.selectPace} t={t}/>}
                                        </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div className="wsEdtDiscr">
                        <div className="diescWrap descTab"  onClick={(e)=> this.selTab("descTab")}>
                            <div className="wsEdtDiscHead wsEditLables">{t("Description")}</div>
                            {
                                this.state.selTab == 'descTab' ?
                                    <div className="selTab"></div>
                                :''
                            }
                        </div>
                        {
                            customAttribute.length >0 && <div className="diescWrap customeAttrTap" onClick={(e)=> this.selTab("customeAttrTap")}>
                                <div className="wsEdtDiscHead wsEditLables " >{t("Custom Attributes")}</div>
                                {
                                    this.state.selTab == 'customeAttrTap' ?
                                        <div className="selTab"></div>
                                    :''
                                }
                            </div>
                        }
                        <div className="boderBottom"></div>

                        {
                            (this.state.selTab == 'descTab' && !canEditAttribute) ?
                                <div className="wsEdtDiscData discEdit " >
                                    <div dangerouslySetInnerHTML={WbMarkdownHtml(goal)} />
                                </div>
                            :''
                        }

                         {
                            (this.state.selTab == 'descTab' && canEditAttribute) ?
                                <div   id="editDisc" style={{display:"none"}} >
                                    <div dangerouslySetInnerHTML={WbMarkdownHtml(goal)} />
                                </div>
                            :''
                        }


                        {
                            this.state.selTab == 'customeAttrTap' && customAttribute.length >0  ?
                            <div className="" id="customAttrDiv">
                               <CustomeAttrDisplay customAttribute={customAttribute} updateCustomAttribute={this.updateCustomAttribute} canEditAttribute={canEditAttribute} />
                            </div>
                            : ''
                        }
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div className="wsEdtButtons">
                    {   canEditAttribute &&
                        <div className="wsEdtButtonsWrapper">
                            <input className="btn_cancel" type="button"
                                defaultValue={t("Cancel")} onClick={(e) => this.cancelWsProps(e)}/>
                            <input className="btn_save" type="button"
                                defaultValue={t("Save")} onClick={(e) => this.submitWsProps(e)}/>
                        </div>
                    }
                    </div>
                    <div style={{clear:"both"}}></div>
                </form>
            </div>
        );
    }

}

class ChageTeamLead extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            content: {},
            searchText: '',
            initialItems: this.props.leadList,
            searchData:{},
            done:0
        };
        this.searchText = this.searchText.bind(this);
        this.filteredData = this.filteredData.bind(this);
    }

    searchText(e){
        var searchText = e.target.value;
        this.setState({
              searchText: searchText
        });
        let _this = this;
        let  wsId = this.props.item;
        let content ;
        let term = searchText;
        let param = {};
        param.term = term;
        param.board = wsId;
        param.urlappent = "&canAddNonMember=false&canAddNonMemberDefaultTeam=false&showNonMemberAdd=false&self=false&showOrgUsers=false";
        param.JsonResponse = "&returnJson=true"
        if(term.length >= 3){
            $.ajax({
                url: wbConfig.baseUrl + '/activity/SearchViewAssigniList',
                type: 'get',
                data: param
            })
            .done(function(response){
                _this.setState({
                      content: response.data,
                      done:1
                });
                removeLoaderWidget();
            })
        }
        if(Object.keys(this.state.content).length > 0){
            var filteredDataList = this.state.content.filter(this.filteredData);
            this.setState({
              content: filteredDataList
            });
        }
    }

    filteredData(item){
        var searchText = this.state.searchText;
        if(searchText){
            let searchTextLowerCase = searchText.toLowerCase();
            let itemFirstName = item.name.toLowerCase();
            let itemLastName = item.lastName.toLowerCase();
            return itemFirstName.indexOf(searchTextLowerCase) !== -1 || itemLastName.indexOf(searchTextLowerCase) !== -1 ;
        }
        else{
          return true;
        }
    }

    render(){
        const { t } = this.props;
        let _this = this;
        let userLists = this.state.content;
        let noSelf = this.state.content.noSelf;
        let uid = this.state.content.id;
        let placeholder = t("Type a person's name to search");
        return(
                <div className="changeLeadWrapper" id="changeLeadWrapper">
                    <div className="searchSection">
                        <div className="search_submit_div" >
                          <img id="searchTag_submit" title="Search for person's name" width="17px" height="16px" src={wbConfig.imageCdnUrl+"/images/icons/main_menu/search.png"} />
                        </div>
                        <input className="leadSearchInputbox gbl-text-entry text-field" placeholder={placeholder} onChange={this.searchText} />
                    </div>

                    <div className="searchdata">
                        {
                            this.state.done == 1 && userLists && userLists.map((item,index) => (
                            <div key={"owner_"+item.id} className="memberNameSearch memberNameDiv" data-id={item.id}    onClick={() => this.props.selectLead(item.name,item.lastName,item.pic,item.id)}>
                                <div className="namesWrap" >
                                    <span className="memberName ">{ (item.id == uid && noSelf) ? "Self" : item.name }</span>
                                    <span className="memberLastName">{ (item.id == uid && noSelf) ? " " : item.lastName}</span>
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>
        );
    }

}

class ChangeHealth extends React.Component{

    constructor(props){
        super(props);
    }

    render(){
        const { t } = this.props;
        return(
               <div className="wsHealthList  showHealth" >
                    <div className="clickable healthVal"   data-url={HEALTH_GOOD}
                    onClick={() => this.props.selectHealt(t("GOOD"),"uptriangle.png",HEALTH_GOOD)}>
                        <div className="inlineBlock healthValDiv">{t("GOOD")}</div>
                        <img className="wsEditPopupHealth" width="10px"  src={wbConfig.imageCdnUrl+"/images/icons/uptriangle.png"} />
                    </div>

                    <div className="clickable healthVal"   data-url={HEALTH_OK} onClick={() => this.props.selectHealt(t("OK"),"sidetriangle.png",HEALTH_OK)}>
                        <div className="inlineBlock healthValDiv">{t("OK")}</div>
                        <img className="wsEditPopupHealth" width="10px"  src={wbConfig.imageCdnUrl+"/images/icons/sidetriangle.png"} />
                    </div>

                    <div className="clickable healthVal"   data-url={HEALTH_RISK} onClick={() => this.props.selectHealt(t("RISK"),"red-arrow.png",HEALTH_RISK)}>
                        <div className="inlineBlock healthValDiv">{t("RISK")}</div>
                        <img className="wsEditPopupHealth" width="10px"  src={wbConfig.imageCdnUrl+"/images/icons/red-arrow.png"} />
                    </div>
               </div>
               );
    }
}

class ChangePriority extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        const { t } = this.props;
        return(
            <div className="showPriority">
            <div className="inlineBlock clickable priorityVal"  data-url={PORIORITY_P1}
            onClick={() => this.props.selectPriority(t("P1"),PORIORITY_P1)} >
                {t("P1")}
            </div>
            <div className="inlineBlock clickable priorityVal"  data-url={PORIORITY_P2}
            onClick={() => this.props.selectPriority(t("P2"),PORIORITY_P2)}>
                {t("P2")}
            </div>
            <div className="inlineBlock clickable priorityVal"  data-url={PORIORITY_P3}
            onClick={() => this.props.selectPriority(t("P3"),PORIORITY_P3)}>
                {t("P3")}
            </div>
            <div className="inlineBlock clickable priorityVal"  data-url={PORIORITY_P4}
            onClick={() => this.props.selectPriority(t("P4"),PORIORITY_P4)}>
                {t("P4")}
            </div>
                <div className="inlineBlock clickable priorityVal"  data-url={PORIORITY_P5}
                onClick={() => this.props.selectPriority(t("P5"),PORIORITY_P5)}>
                {t("P5")}
            </div>
        </div>
        );
    }
}

class ChangePace extends React.Component{

    constructor(props){
        super(props);
    }

    render(){
        const { t } = this.props;
        return(
            <div className="showPacePopup">
        <div className="clickable paceVal"   data-url={PACE_FAST} onClick={() => this.props.selectPace(t("FAST"),PACE_FAST)}>
            <div className="inlineBlock paceValDiv">{t("FAST")}</div>
            <div className="inlineBlock">
                <img width="10px" className="paceValImg" src={wbConfig.imageCdnUrl+"/images/icons/uptriangle.png"} />
            </div>
        </div>

        <div className="clickable paceVal"   data-url={PACE_STEADY} onClick={() => this.props.selectPace(t("STEADY"),PACE_STEADY)}>
            <div className="inlineBlock paceValDiv">{t("STEADY")}</div>
            <div className="inlineBlock">
                <img width="10px" className="paceValImg" src={wbConfig.imageCdnUrl+"/images/icons/sidetriangle.png"} />
            </div>
        </div>

        <div className="clickable paceVal"   data-url={PACE_SLOW} onClick={() => this.props.selectPace(t("SLOW"),PACE_SLOW)}>
            <div className="inlineBlock paceValDiv">{t("SLOW")}</div>
            <div className="inlineBlock">
                <img width="10px" className="paceValImg" src={wbConfig.imageCdnUrl+"/images/icons/downtriangle.png"} />
            </div>
        </div>

        </div>
        );
    }
}

export default withTranslation()(ViewWsPopupComp);
